import './style/OfferDetails.css';
import React, { useState, useEffect } from 'react';
import Button from './Button';
import { formatToCurrency, formatToCurrencyExpanded, formatPercentWithCommas, formatNumberWithCommas, formatDisplayNumber, expiresInTextFromDate, colorFromNumber } from '../../util/Calculate';
import ScoreBar from './ScoreBar';
import Divider from './Divider';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { Text, Button as NewButton, Navigate } from '@harperai/materialize-design-system';

const OfferDetails = ({ handleAccept, handleReject }) => {
    const keystoneTrayData = useSelector((state) => state?.keystone?.trayData);
    const keystoneTrayType = useSelector((state) => state?.keystone?.trayType);
    const keystoneInterfaceCalls = useSelector((state) => state?.keystoneInterface?.calls);

    const [acceptLoading, setAcceptLoading] = useState(false);
    const [rejectLoading, setRejectLoading] = useState(false);
    const { page, tabName } = useParams();
    const navigate = useNavigate();


    
    const handleAcceptOffer = (accept) => {
        if (accept) {
            setAcceptLoading(true);
            handleAccept(keystoneTrayType);
        } else {
            setRejectLoading(true);
            handleReject(keystoneTrayType);
        }
    };

    useEffect(() => {
        if (keystoneInterfaceCalls?.some(item =>
            item.type === "offer" &&
            item.action === "respond" &&
            (item.status === "fulfilled" || item.status === "rejected")
        )) {
            setAcceptLoading(false);
            setRejectLoading(false);
            navigate(`/${page}/${tabName}`);
        }
    }, [keystoneInterfaceCalls, navigate, page, tabName]);

    const handleCloseTray = () => {
        navigate(`/${page}/${tabName}`);
    };

    const totalItems = keystoneTrayData?.offer_items?.reduce((acc, item) => {
        return acc + item.quantity;
    }, 0);

    const totalPrice = keystoneTrayData?.offer_items?.reduce((acc, item) => {
        return acc + item.total_price;
    }, 0);

    return keystoneTrayData && (
        <div className="keystone-offer-details product-vertical-container width-100 flex-1">
            <div className="keystone-tray-header black-bg product-vertical-container width-100 space-between pad-l v-gap-display" style={{
                // mixBlendMode: "difference",
                // backgroundColor: (() => {
                //     const { hue, sat, light } = colorFromNumber(keystoneTrayData.offer_number);
                //     return `hsl(${hue}, ${sat}%, ${light}%)`;
                // })()
            }}>
                <div className="flex horizontal gap-xl space-between align-start">
                    <Button
                        label="Dismiss"
                        onClick={handleCloseTray}
                        textColor="white"
                        onBrand={true} />

                    <div className="flex vertical align-end gap-m">
                        <Text size="caption" bold={true} variant="white" classes="align-end ellipsis" mono={true}>Offer: {keystoneTrayData.offer_number.toString().padStart(12,'0').replace(/(\d{4})(\d{4})(\d{4})/, '$1-$2-$3')}</Text>
                        {keystoneTrayData.expiration_date && (keystoneTrayData.status === "AWAITING_RESPONSE" || keystoneTrayData.status === "EXPIRED") && (
                            <div className="status-chip flex horizontal grey-bg round-s gap-s">
                                <div class={`small-circle ${expiresInTextFromDate(keystoneTrayData.expiration_date).includes("Expired") ? "circle-negative" : "circle-warning"}`}/>
                                <Text size="micro" bold={true} mono={true}>{expiresInTextFromDate(keystoneTrayData.expiration_date)}</Text>
                            </div>
                        )}
                        {keystoneTrayData.offer_type === "BUY_IT_NOW" && (
                            <div className="status-chip flex horizontal grey-bg round-s gap-m">
                                <Text size="micro" bold={true} mono={true}>Auto-Accepted</Text>
                            </div>
                        )}
                    </div>
                </div>
                <div className="product-vertical-container gap-m">
                    <div className="flex vertical gap-s">
                        <div className="flex vertical">
                            <Text size="paragraph" bold={true} variant="white">{totalItems} Items</Text>
                            <Text size="h1" bold={true} variant="yellow" mono={true}>{formatToCurrency(totalPrice)}</Text>
                        </div>
                        <Text size="caption" variant="white" mono={true} bold={true}>From {keystoneTrayData?.unique_locations?.length} Location{keystoneTrayData?.unique_locations?.length > 1 ? "s" : ""}</Text>
                    </div>
                </div>
            </div>
            <div className="product-vertical-container grey-bg flex-1 width-100 overflow-auto">
                <div className="product-vertical-container flex-1 width-100 pad-m gap-l overflow-auto">
                    {keystoneTrayData?.unique_locations?.map((location, index) => (
                        <div key={index} className="keystone-card flex vertical">
                            <div className="pad-m">
                                <Text bold={true} size="title">Warehouse: {location.warehouse_name}</Text>
                            </div>
                            <Divider />
                            <div className="flex vertical pad-m gap-s">
                                {keystoneTrayData?.offer_items?.filter((offer) => offer.inventory_item?.warehouse_name === location.warehouse_name).map((item, index) => (
                                    <Navigate key={index} unsetHeight={true} unsetPadding={true} variant="grey" href={`/inventory?id=${item.inventory_item?.id}`}>
                                        <div className="flex vertical gap-m width-100">
                                            <div className="flex horizontal gap-s space-between flex-wrap">
                                                <div className="flex horizontal v-gap-m align-center space-between grow-1">
                                                    <div className="flex vertical">
                                                        <Text size="caption" variant="secondary" bold={true}>{item.inventory_item?.manufacturer}</Text>
                                                        <Text size="paragraph" bold={true} mono={true}>{item.inventory_item?.mpn}</Text>
                                                    </div>
                                                </div>
                                                <div className="flex horizontal flex-wrap grow-1 gap-m">
                                                    <div className="flex grow-1 vertical white-bg pad-xs round-s">
                                                        <Text size="caption" variant="secondary" bold={true}>Quantity</Text>
                                                        <Text size="paragraph" bold={true} mono={true}>{formatNumberWithCommas(item.quantity)}</Text>
                                                    </div>
                                                    <div className="flex vertical grow-1 white-bg pad-xs round-s">
                                                        <Text size="caption" variant="secondary" bold={true}>Unit Price</Text>
                                                        <Text size="paragraph" bold={true} mono={true}>{formatToCurrency(item.unit_price)}</Text>
                                                    </div>
                                                    <div className="flex grow-1 vertical white-bg pad-xs round-s">
                                                        <Text size="caption" bold={true} variant="secondary">Total</Text>
                                                        <Text size="paragraph" bold={true} mono={true} classes="align-right">{formatToCurrency(item.total_price)}</Text>
                                                    </div>
                                                </div>
                                            </div>
                                            {item.percent_of_unit_cost && <ScoreBar score={item.percent_of_unit_cost / 100} label={formatPercentWithCommas(item.percent_of_unit_cost / 100) + " of Asking Price"} background={false} minLabel="$0.00" maxLabel={formatToCurrencyExpanded(item.inventory_item?.unit_value)} />}
                                        </div>
                                    </Navigate>
                                ))}
                            </div>
                        </div>
                    ))}
                    {keystoneTrayData.shipments?.length > 0 && (
                        <div className="keystone-card flex vertical">
                            <div className="pad-m">
                                <Text bold={true} size="title">Shipment{keystoneTrayData.shipments?.length > 1 ? "s" : ""}</Text>
                            </div>
                            <Divider />
                            <div className="flex vertical pad-m gap-s">
                                {keystoneTrayData.shipments?.map((shipment, index) => (
                                    <Navigate href={
                                        `/shipments/${shipment.status === "PENDING" ? "awaiting-shipment" : "shipped"}?id=${shipment.id}`
                                    } key={shipment.id} classes="width-100 pad-s" variant="grey" size="large" unsetHeight={true} unsetPadding={true}>
                                        <div className="flex horizontal gap-xl width-100 space-between align-center">
                                            <Text size="paragraph" mono={true} bold={true}>{formatDisplayNumber(shipment.shipment_number)}</Text>
                                            <div className="status-chip flex horizontal white-bg round-s gap-m">
                                                <div class={`small-circle circle-${shipment.status === "PENDING" ? "negative" : shipment.status === "SHIPPED" ? "warning" : "positive"}`}/>
                                                <Text size="micro" bold={true} mono={true}>{shipment.status === "PENDING" ? "Awaiting Shipment" : shipment.status === "SHIPPED" ? "Shipped" : "Delivered"}</Text>
                                            </div>
                                        </div>
                                    </Navigate>
                                ))}
                            </div>
                        </div>
                    )}
                    {keystoneTrayData.payouts?.length > 0 && (
                        <div className="keystone-card flex vertical">
                            <div className="pad-m">
                                <Text bold={true} size="title">Payout{keystoneTrayData.payouts?.length > 1 ? "s" : ""}</Text>
                            </div>
                            <Divider />
                            <div className="flex vertical pad-m gap-s">
                                {keystoneTrayData.payouts?.map((payout, index) => (
                                    <Navigate href={
                                        `/payouts/${payout.status === "ON_HOLD" ? "on-hold" : "sent"}?id=${payout.id}`
                                    } key={payout.id} classes="width-100" variant="grey" size="large" unsetHeight={true} unsetPadding={true}>
                                        <div className="flex horizontal gap-xl width-100 space-between align-center">
                                            <Text size="paragraph" mono={true} bold={true}>{formatDisplayNumber(payout.payout_number)}</Text>
                                            <div className="status-chip flex horizontal white-bg round-s gap-m">
                                                <div class={`small-circle circle-${payout.status === "ON_HOLD" ? "warning" : "positive"}`}/>
                                                <Text size="micro" bold={true} mono={true}>{payout.status === "ON_HOLD" ? "On Hold" : "Sent"}</Text>
                                            </div>
                                        </div>
                                    </Navigate>
                                ))}
                            </div>
                        </div>
                    )}
                </div>
                <div className="product-vertical-container white-bg box-shadow-up tray-bottom">
                    <Divider />
                    <div className="flex vertical gap-l">
                        <div className="flex pad-l no-pad-bot">
                            <Text size="h6" bold={true}>Offer Summary</Text>
                        </div>
                        <div className="flex vertical gap-s round-m pad-l no-pad-top">
                            <div className="flex horizontal space-between align-center gap-m">
                                <div className="flex vertical">
                                    <Text size="title" bold={true}>Your Return</Text>
                                    <Text size="caption" bold={true} variant="secondary">Returns {formatPercentWithCommas(keystoneTrayData?.totalOfferPercentOfUnitCost)} of your asking price</Text>
                                </div>
                                <Text size="h6" mono={true} bold={true}>{formatToCurrency(keystoneTrayData?.total_price)}</Text>
                            </div>
                            <div className="positive-bg pad-xs round-s center-text">
                                <Text size="caption" bold={true} variant="positive">Amount is minus all fees.</Text>
                            </div>
                        </div>
                    </div>
                    <div className="flex vertical">
                        {keystoneTrayData?.status === "AWAITING_RESPONSE" && (
                            <div className="product-horizontal-container justify-end pad-l no-pad-top h-gap-l">
                                <NewButton
                                    size="large"
                                    variant="secondary"
                                    loading={rejectLoading}
                                    onClick={() => handleAcceptOffer(false)}
                                    classes="flex grow-1 space-between"
                                    icon="close-square">
                                    Reject Offer
                                </NewButton>
                                <NewButton
                                    size="large"
                                    loading={acceptLoading}
                                    onClick={() => handleAcceptOffer(true)}
                                    classes="flex grow-1 space-between"
                                    icon="check-square">
                                    Accept Offer
                                </NewButton>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default React.memo(OfferDetails);